import { PUBLIC_URL } from "./common.constants";

export const galleryImages = [
  {
    id: 1,
    url: './assets/image/1.jpg',
    title: 'Image 1',
    description: 'Image 1 description',
    category: 'Category 1',
  },
  {
    id: 2,
    url: './assets/image/2.jpg',
    title: 'Image 2',
    description: 'Image 2 description',
    category: 'Category 1',
  },
  {
    id: 3,
    url: './assets/image/3.jpg',
    title: 'Image 3',
    description: 'Image 3 description',
    category: 'Category 1',
  },
  {
    id: 4,
    url: './assets/image/4.jpg',
    title: 'Image 4',
    description: 'Image 4 description',
    category: 'Category 1',
  },
  {
    id: 5,
    url: './assets/image/5.jpg',
    title: 'Image 5',
    description: 'Image 5 description',
    category: 'Category 1',
  },

  {
    id: 6,
    url: './assets/image/1.jpg',
    title: 'Image 1',
    description: 'Image 1 description',
    category: 'Category 1',
  },
  {
    id: 7,
    url: './assets/image/5.jpg',
    title: 'Image 5',
    description: 'Image 5 description',
    category: 'Category 1',
  },
  {
    id: 8,
    url: './assets/image/1.jpg',
    title: 'Image 1',
    description: 'Image 1 description',
    category: 'Category 1',
  },
  {
    id: 9,
    url: './assets/image/3.jpg',
    title: 'Image 3',
    description: 'Image 3 description',
    category: 'Category 1',
  },
  {
    id: 10,
    url: './assets/image/4.jpg',
    title: 'Image 4',
    description: 'Image 4 description',
    category: 'Category 1',
  },
  {
    id: 11,
    url: './assets/image/5.jpg',
    title: 'Image 5',
    description: 'Image 5 description',
    category: 'Category 1',
  },

  {
    id: 12,
    url: './assets/image/2.jpg',
    title: 'Image 2',
    description: 'Image 2 description',
    category: 'Category 1',
  },
  {
    id: 13,
    url: './assets/image/1.jpg',
    title: 'Image 1',
    description: 'Image 1 description',
    category: 'Category 1',
  },
  {
    id: 14,
    url: './assets/image/2.jpg',
    title: 'Image 2',
    description: 'Image 2 description',
    category: 'Category 1',
  },
  {
    id: 15,
    url: './assets/image/3.jpg',
    title: 'Image 3',
    description: 'Image 3 description',
    category: 'Category 1',
  },
  {
    id: 16,
    url: './assets/image/4.jpg',
    title: 'Image 4',
    description: 'Image 4 description',
    category: 'Category 1',
  },
];

export const bgImages = [
  {
    id: 1,
    url: './assets/image/1.jpg',
    title: 'Image 1',
    description: 'Image 1 description',
    tintIntensity: 75,
    glore: true,
    category: {
      background: "Ganage1",
      window: "0.3",
      numberPlate: "White Mask"
    },
    isSelected: true,
  },
  {
    id: 2,
    url: './assets/image/2.jpg',
    title: 'Image 2',
    description: 'Image 2 description',
    tintIntensity: 75,
    glore: true,
    category: {
      background: "Ganage1",
      window: "0.3",
      numberPlate: "White Mask"
    },
  },
  {
    id: 3,
    url: './assets/image/3.jpg',
    title: 'Image 3',
    description: 'Image 3 description',
    tintIntensity: 75,
    glore: true,
    category: {
      background: "Ganage1",
      window: "0.3",
      numberPlate: "White Mask"
    },
  },
  {
    id: 4,
    url: './assets/image/4.jpg',
    title: 'Image 4',
    description: 'Image 4 description',
    tintIntensity: 75,
    glore: true,
    category: {
      background: "Ganage1",
      window: "0.3",
      numberPlate: "White Mask"
    },
  },
];

export const BGs = [
  {
    "name": "white-bg",
    "id": "-",
    "thumbnail": PUBLIC_URL + "/assets/image/background/white-bg.png",
    "isSelected": "-"
  },
  {
    "name": "pxc-bg",
    "id": "pxc-bg",
    "thumbnail": PUBLIC_URL + "/assets/image/background/pxc-bg.png"
  },
  {
    "name": "background-2",
    "id": "background-2",
    "thumbnail": PUBLIC_URL + "/assets/image/background/background-2.jpg"
  },
  {
    "name": "normal",
    "id": "normal",
    "thumbnail": PUBLIC_URL + "/assets/image/background/normal.jpg"
  }
]

export const Showroom2D = [
  {
    "name": "front-left__boden1",
    "title": "Boden-1",
    "id": "kw8jd",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden1.jpg",
  },
  {
    "name": "front-left__boden2",
    "title": "Boden-2",
    "id": "bdn3d",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden2.jpg",
  },
  {
    "name": "front-left__boden3",
    "title": "Boden-3",
    "id": "md73z",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden3.jpg",
  },
  {
    "name": "front-left__boden4",
    "title": "Boden-4",
    "id": "j62hs",
    "thumbnail": "./assets/image/showrooms/2D/front-left__boden4.jpg",
  },
  {
    "name": "front-left__boden5",
    "title": "Boden-5",
    "id": "a47zd",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden5.jpg",
  },
  {
    "name": "front-left__boden6",
    "title": "Boden-6",
    "id": "th0rs",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden6.jpg",
  },
  {
    "name": "front-left__boden7",
    "title": "Boden-7",
    "id": "od9jr",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden7.jpg",
  },
  {
    "name": "front-left_boden8",
    "title": "Boden-8",
    "id": "9b3qxer",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden8.jpg",
  },
  {
    "name": "front-left_boden9",
    "title": "Boden-9",
    "id": "95y5g2q",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden9.jpg",
  },
  {
    "name": "front-left_boden10",
    "title": "Boden-10",
    "id": "7opn1d3",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden10.jpg",
  },
  {
    "name": "front-left_boden10",
    "title": "Boden-10",
    "id": "7opn1d3",
    "thumbnail": "./assets/image/showrooms/2D/front-left_boden10.jpg",
  },


]

export const Showroom3D = [
  {
    "name": "front-left_showroom1",
    "id": "bk46d",
    "title": "showroom-1",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom1.jpg",
  },
  {
    "name": "front-left_showroom2",
    "id": "mwcxu",
    "title": "showroom-2",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom2.jpg",
  },
  {
    "name": "front-left_showroom3",
    "id": "o9ih7",
    "title": "showroom-3",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom3.jpg",
  },
  {
    "name": "front-left_showroom4",
    "id": "wt64p",
    "title": "showroom-4",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom4.jpg",
  },
  {
    "name": "front-left_showroom5",
    "id": "7s9dm",
    "title": "showroom-5",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom5.jpg",
  },
  {
    "name": "front-left_showroom6",
    "id": "t0rn7",
    "title": "showroom-6",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom6.jpg",
  },
  {
    "name": "front-left_showroom7",
    "id": "7xq5d",
    "title": "showroom-7",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom7.jpg",
  },
  {
    "name": "front-left_showroom8",
    "id": "b8s7f",
    "title": "showroom-8",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom8.jpg",
  },
  {
    "name": "front-left_showroom9",
    "id": "jw8j4",
    "title": "showroom-9",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom9.jpg",
  },
  {
    "name": "front-left_showroom10",
    "id": "cx6xo",
    "title": "showroom-10",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom10.jpg",
  },
  {
    "name": "front-left_showroom11",
    "id": "ypa642d",
    "title":"showroom-11",
    "thumbnail": "./assets/image/showrooms/3D/showroom-11.jpg",
  },
  {
    "name": "Mitsubishi-showroom",
    "id": "hdf3s",
    "title": "Mitsubishi-showroom",
    "thumbnail": "./assets/image/showrooms/3D/hdf3s.jpg",
  },
  {
    "name": "Mitsubishi-showroom",
    "id": "hdf3s",
    "title": "Mitsubishi-showroom",
    "thumbnail": "./assets/image/showrooms/3D/front-left_showroom10.jpg",
  },
]

export const rawDataNumberPlates = [
  {
    "name": "No Mask",
    "id": "0",
    "thumbnail": ""
  },
  {
    "name": "CC_license_plate_PicD",
    "id": "CC_license_plate_PicD",
    "thumbnail": PUBLIC_URL + "/assets/image/licenceplate/CC_license_plate_PicD.png"
  },
  {
    "name": "license_plate_emptyBlack",
    "id": "license_plate_emptyBlack",
    "thumbnail": PUBLIC_URL + "/assets/image/licenceplate/license_plate_emptyBlack.png"
  },
  {
    "name": "license_plate_emptyGray",
    "id": "license_plate_emptyGray",
    "thumbnail": PUBLIC_URL + "/assets/image/licenceplate/license_plate_emptyGray.png"
  },
  {
    "name": "license_plate_emptyLightGray",
    "id": "license_plate_emptyLightGray",
    "thumbnail": PUBLIC_URL + "/assets/image/licenceplate/license_plate_emptyLightGray.png"
  }
];
